var _defs, _g, _g2, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuessButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 160.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke:#000;stroke-miterlimit:10;}.cls-3{font-family:MyriadPro-Regular, 'Myriad Pro';font-size:42.58px;}.cls-4{fill:#fcc012;}.cls-2{fill:none;stroke-width:.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "50.66 16.31 67.36 4.87 202.49 136.27 185.79 147.7 50.66 16.31"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.34,6.68L200.3,135.97l-14.48,9.92L52.86,16.6l14.48-9.92m.03-1.81l-16.71,11.44L185.79,147.7l16.71-11.44L67.38,4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.72,17.32c-4.78-3.89-6.75-8.21-5.14-10.54,.5-.72,1.28-1.25,2.23-1.53l4.46-3.05c.5-.72,1.28-1.25,2.23-1.53,3.05-.85,7.92,1.49,11.83,5.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 60.49,
    y1: 20.33,
    x2: 179.4,
    y2: 135.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 163.76,
    y1: 112.86,
    x2: 78.22,
    y2: 29.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 69.41,
    y1: 14.22,
    x2: 188.31,
    y2: 129.85
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.79 147.7 186.89 146.95 212.52 159.85 185.79 147.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "212.51 159.86 202.49 136.27 201.38 137.02"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "207.64 157.63 210.55 155.64 212.51 159.86 207.64 157.63"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "193.36 5.52 210.06 16.95 74.94 148.34 58.24 136.91 193.36 5.52"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.88,17.25L74.92,146.54l-14.48-9.92L193.39,7.33l14.48,9.92m2.2-.29l-16.71-11.44L58.24,136.91l16.71,11.44L210.07,16.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.5,7.35c3.87-4.52,8.73-6.85,11.83-5.96,.95,.28,1.73,.81,2.23,1.53l4.46,3.05c.95,.28,1.73,.81,2.23,1.53,1.56,2.3-.43,6.62-5.14,10.54"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 190.22,
    y1: 14.11,
    x2: 71.31,
    y2: 129.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.46,
    y1: 113.16,
    x2: 182,
    y2: 29.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 199.13,
    y1: 20.22,
    x2: 80.22,
    y2: 135.84
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.24 136.91 59.34 137.66 48.22 160.5 58.24 136.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48.21 160.49 74.94 148.34 73.84 147.59"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "50.04 156.2 52.95 158.19 48.21 160.49 50.04 156.2"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(.1 83.49) rotate(.34) scale(2.35 1) skewX(-.07)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Guess"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuessButton);
export default __webpack_public_path__ + "static/media/guess_button.42603ea0a1194e6449805ca7161f46f1.svg";
export { ForwardRef as ReactComponent };